import React from "react";

/**
 * SortableTh — Round 30. Drop-in replacement for a plain <th> that makes
 * the column click-to-sort. Pairs with useTableSort.
 *
 *   <SortableTh col={c} sort={sort} onToggle={toggleSort}
 *               className="text-end" />
 *
 * Shows ↑ / ↓ when the column is the active sort, a faint sort glyph on
 * hoverable columns otherwise. Columns with type "none" (action columns)
 * render as a plain, unsortable <th>.
 */
const SortableTh = ({ col, sort, onToggle, className = "", children }) => {
    const label = children ?? col.label;
    if (!col || col.type === "none" || col.sortable === false) {
        return <th className={className}>{label}</th>;
    }
    const active = sort && sort.id === col.id;
    const dir = active ? sort.dir : 0;
    return (
        <th
            className={className}
            role="button"
            tabIndex={0}
            aria-sort={active ? (dir === 1 ? "ascending" : "descending") : "none"}
            title={`Sort by ${col.label}`}
            onClick={() => onToggle(col.id)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onToggle(col.id); }
            }}
            style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
        >
            {label}
            <i
                aria-hidden="true"
                className={
                    dir === 1 ? "ri-arrow-up-s-line align-bottom ms-1"
                  : dir === -1 ? "ri-arrow-down-s-line align-bottom ms-1"
                  : "ri-expand-up-down-line align-bottom ms-1"
                }
                style={{ fontSize: 14, opacity: active ? 0.95 : 0.35 }}
            />
        </th>
    );
};

export default SortableTh;
